







import {Component, Prop, Vue} from "vue-property-decorator";
import VueI18n from "vue-i18n";

import LocaleMessage = VueI18n.LocaleMessage;

@Component({
  name: "DataPair",
  components: {

  },
})
export default class DataPair extends Vue {
  @Prop()
  private label!: string|LocaleMessage;

  @Prop({ default: false })
  private value!: string|LocaleMessage;
}
